<template>
  <div>

    <section class="hold-content">
      <article id="homepage-content">
        <section class="home-hero master" :class="(doc.buttonState > 0)?'shown':''">
          <div class="floating-logos">
            <a class="image-main" style="box-shadow: 0px 4px 40px 10px #2235FB;"><img src="  https://www.studiodome.com/img/home/latest/Microsoftxbox-white.png"></a>
            <a class="image-main" style="box-shadow: 0px 4px 40px 10px #0F9691;"><img src="  https://www.studiodome.com/img/home/latest/AmazonStore-white.png"></a>
            <a class="image-main" style="box-shadow: 0px 4px 40px 10px #2235FB;"><img src="  https://www.studiodome.com/img/home/latest/psp-white.png"></a>
            <a class="image-main" style="box-shadow: 0px 4px 40px 10px #2235FB;"><img src="  https://www.studiodome.com/img/home/latest/Netflix-white.png"></a>
            <a class="image-main" style="box-shadow: 0px 4px 40px 10px #0F9691;"><img src="  https://www.studiodome.com/img/home/latest/AmazonVideo-white.png"></a>
            <a class="image-main" style="box-shadow: 0px 4px 40px 10px #2235FB;"><img src="  https://www.studiodome.com/img/home/latest/YouTube-white.png"></a>
            <a class="image-main" style="box-shadow: 0px 4px 40px 10px #2235FB;"><img src="  https://www.studiodome.com/img/home/latest/Vimeo-white.png"></a>
            <a class="image-main" style="box-shadow: 0px 4px 40px 10px #0F9691;"><img src="  https://www.studiodome.com/img/home/latest/GooglePlay-white.png"></a>
            <a class="image-main" style="box-shadow: 0px 4px 40px 10px #2235FB;"><img src="  https://www.studiodome.com/img/home/latest/hbo-white.png"></a>
            <a class="image-main" style="box-shadow: 0px 4px 40px 10px #2235FB;"><img src="  https://www.studiodome.com/img/home/latest/AppleTV-white.png"></a>
            <a class="image-main" style="box-shadow: 0px 4px 40px 10px #0F9691;"><img src="  https://www.studiodome.com/img/home/latest/hulu-white.png"></a>
            <a class="image-main" style="box-shadow: 0px 4px 40px 10px #2235FB;"><img src="  https://www.studiodome.com/img/home/latest/IMDbTV-white.png"></a>
            <a class="image-notmain" style="box-shadow: 0px 4px 40px 10px #2235FB;"><img src=" https://www.studiodome.com/img/home/latest/Starz-white.png"></a>
            <a class="image-notmain" style="box-shadow: 0px 4px 40px 10px #0F9691;"><img src=" https://www.studiodome.com/img/home/latest/iTunes-white.png"></a>
            <a class="image-notmain" style="box-shadow: 0px 4px 40px 10px #2235FB;"><img src=" https://www.studiodome.com/img/home/latest/DirecTV-white.png"></a>
            <a class="image-notmain" style="box-shadow: 0px 4px 40px 10px #2235FB;"><img src=" https://www.studiodome.com/img/home/latest/Shaw-white.png"></a>
            <a class="image-notmain" style="box-shadow: 0px 4px 40px 10px #0F9691;"><img src=" https://www.studiodome.com/img/home/latest/Redbox-white.png"></a>
            <a class="image-notmain" style="box-shadow: 0px 4px 40px 10px #2235FB;"><img src=" https://www.studiodome.com/img/home/latest/Hoopla-white.png"></a>
            <a class="image-notmain" style="box-shadow: 0px 4px 40px 10px #0F9691;"><img src=" https://www.studiodome.com/img/home/latest/Telus-white.png"></a>
            <a class="image-notmain" style="box-shadow: 0px 4px 40px 10px #2235FB;"><img src=" https://www.studiodome.com/img/home/latest/Pluto-white.png"></a>
            <a class="image-notmain" style="box-shadow: 0px 4px 40px 10px #0F9691;"><img src=" https://www.studiodome.com/img/home/latest/VUDU-white.png"></a>
            <a class="image-notmain" style="box-shadow: 0px 4px 40px 10px #2235FB;"><img src=" https://www.studiodome.com/img/home/latest/Dish-white.png"></a>
            <a class="image-notmain" style="box-shadow: 0px 4px 40px 10px #2235FB;"><img src=" https://www.studiodome.com/img/home/latest/Tubi-white.png"></a>
            <a class="image-notmain" style="box-shadow: 0px 4px 40px 10px #0F9691;"><img src=" https://www.studiodome.com/img/home/latest/Spectrum-white.png"></a>
            <img class="spec-left" src="https://www.studiodome.com/img/home/bg-gradient-img-1.png">
            <img src="https://www.studiodome.com/img/home/bg-gradient-img-2.png">
          </div>
          <div class="info text-center">
            <img class="main-logo" src="https://www.studiodome.com/img/logo-dome.svg" /> <br />
            <img class="dome-header" src="@/components/custom/delfina/assets/dome-header.png" />
            <h1 class="standard">All of the Access,<br>None of the Fees</h1>
          </div>
        </section> 
        <img class="dome-footer" src="@/components/custom/delfina/assets/dome-footer.png" />  
      </article>
    </section>



    <div id="pos-form">
      <registration-method
        v-for="(registration_method,index) in registration_methods"
        :key="index"
        v-on:changeSelected="changeSelected"
        v-on:changeSelectedTOS="changeSelectedTOS"
        v-on:changeButtonState="changeButtonState"
        v-on:emitRegistrationMethodData="emitRegistrationMethodData"
        v-on:error="handleError"
        :index="index"
        :selected="doc.selected_rm"
        :selected_tos="doc.selected_tos"
        :registration_method="registration_method" />
    </div>
    </div>

</template>

<script>
// import $ from 'jquery'
import RegistrationMethod from '@/components/custom/delfina/PortalRegistrationMethod'

export default {
  name: 'custom_template',
  props: [
    'portal',
    'connection_data'
  ],
  components: {
    'registration-method': RegistrationMethod,
  },
  watch: {
    // Collapse the Terms of Service when registration method changes
    'doc.selected_rm': function(){
      this.doc.selected_tos = null;
    },
  },
  data(){
    return{
      doc: {
        window_width: window.innerWidth,
        selected_rm: null,
        selected_tos: null,
        selected_inline_image: 0,
        selected_background_image: 0,
        support_phone: '8772822519',
        buttonState: 0
      },
      registration_methods: [],
      // Manually setting this up here because not in endpoint
      terms_of_service: `<center><b>TERMS AND CONDITIONS<br>OF INTERNET USE</b><br><br><b>IMPORTANT! PLEASE READ CAREFULLY BEFORE USING. YOUR USE OF THE SERVICES IS YOUR ACKNOWLEDGMENT AND AGREEMENT THAT YOU AGREE WITH THE TERMS SET FORTH BELOW.</b></center><br><br><b>ACCEPTANCE OF TERMS THROUGH USE</b><br>By using these services (the "Services"), you agree to all terms, conditions, and notices contained herein. The Hotel reserves the right, in its sole discretion, to terminate your access to all or part of the Services, with or without notice.<br><br><b>DISCLAIMER OF WARRANTIES</b><br>ALL MATERIALS, INFORMATION, SOFTWARE, PRODUCTS, AND SERVICES INCLUDED IN OR AVAILABLE BY THE HOTEL ARE PROVIDED "AS IS". THE HOTEL, ITS SUBSIDIARIES, AFFILIATES, OWNER, AND ITS REPRESENTATIVES ACCEPT NO LIABILITY FOR ANY PROBLEMS ASSOCIATED WITH YOUR USE OF THE SERVICES, INCLUDING, BUT NOT LIMITED TO, DAMAGE TO YOUR SOFTWARE, HARDWARE, OR OTHER EQUIPMENT; ANY DELAY IN OPERATION OR TRANSMISSION OF THE SERVICES; ANY COMMUNICATIONS LINE FAILURE, THEFT OR DESTRUCTION; ANY PROBLEMS OR TECHNICAL MALFUNCTION OF ANY TELEPHONE NETWORK OR LINES, COMPUTER ON-LINE SYSTEMS, SERVERS, PROVIDERS, OR COMPUTER EQUIPMENT; OR ANY TRAFFIC CONGESTION OF FAILURE OF THE INTERNET OR ANY WEB SITE. THE SERVICES ARE PROVIDED WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, OR NONINFRINGEMENT. THE HOTEL, ITS SUBSIDIARIES, AFFILIATES, OWNER, AND ITS REPRESENTATIVES DO NOT WARRANT THAT THE SERVICES ARE ACCURATE, RELIABLE OR CORRECT; THAT THE SERVICES WILL BE UNINTERRUPTED OR AVAILABLE AT ANY PARTICULAR TIME OR LOCATION; THAT THE SERVICES ARE SECURE OR THAT ANY WIRELESS OR WIRED CONNECTION WILL NOT BE ACCESSED, INTERCEPTED, ALTERED OR DESTROYED IN WHOLE OR IN PART BY AN UNAUTHORIZED THIRD PARTY; THAT ANY DATA FILES, PROGRAMS, PROCEDURES OR INFORMATION (INCLUDING YOUR PERSONALLY IDENTIFIABLE INFORMATION) DOWNLOADED, RECORDED, TRANSMITTED OR INPUT THROUGH THE SERVICES WILL BE SECURE OR PROTECTED FROM UNAUTHORIZED ACCESS TO, ALTERATION, DELETION, DEFECT OR DESTRUCTION; THAT ANY DEFECTS OR ERRORS WILL BE CORRECTED; OR THAT THE CONTENT OR SERVICES ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. SOME JURISDICTIONS DO NOT PERMIT THE EXCLUSION OF CERTAIN WARRANTIES, SO THESE EXCLUSIONS MAY NOT APPLY TO YOU.<br><br><b>LIMITATION OF LIABILITY</b><br>UNDER NO CIRCUMSTANCES SHALL THE HOTEL, ITS SUBSIDIARIES, AFFILIATES, OWNER OR ITS REPRESENTATIVES BE LIABLE FOR ANY DIRECT, INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES THAT RESULT FROM THE USE OF OR INABILITY TO USE, THE SERVICES. THIS LIMITATION APPLIES EVEN IF THE HOTEL HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THE HOTEL'S LIABILITY IN SUCH JURISDICTIONS SHALL BE LIMITED TO THE MAXIMUM EXTENT PERMITTED BY LAW.<br><br><b>INDEMNIFICATION</b><br>You shall defend, indemnify and hold the Hotel and its owners, subsidiaries and other affiliated companies, and their employees, contractors, officers, and directors harmless from all liabilities, claims, and expenses, including attorney's fees resulting from your use or misuse of the Services.<br><br><b>THIRD PARTY SITES</b><br>Your use of the Services may business center you to other sites on the Internet. These sites may contain information or material that some people may find inappropriate or offensive. These other sites are not under the control of the Hotel, and you acknowledge that the Hotel is not responsible for the accuracy, legality, decency, or any other aspect of the content of such sites. The inclusion of such a business center does not imply endorsement of the site by the Hotel.<br><br><b>RULES OF CONDUCT</b><br>You agree not to use these Services for unlawful purposes or in an offensive manner, including, without limitation, usage that (i) is threatening, abusive, harassing, defamatory, libelous, deceptive, fraudulent, invasive of another's privacy, tortious, or (ii) contains language (sexual or otherwise) of a violent or threatening nature directed at another individual or group of individuals, or victimizes, harasses, degrades, or intimidates an individual or group of individuals on the basis of religion, gender, sexual orientation, race, ethnicity, age, or disability. You shall also be prohibited from usage that infringes any patent, trademark, trade secret, copyright, right of publicity, or other proprietary right of any party (collectively, "Intellectual Property"). You shall not introduce any software viruses or any other computer code, files, or programs that are designed or intended to disrupt, damage, or limit the functioning of any software, hardware, or telecommunications equipment or to damage or obtain unauthorized access to any data or other information of any third party. You further agree that you will not knowingly solicit or collect personal information from a minor (anyone under 18 yrs old) without appropriate prior verifiable parental consent. The Hotel makes no representation that materials accessed through the Service are appropriate or available for use in locations outside the United States, and accessing them from territories where their contents are illegal is prohibited.<br><br><b>MONITORING</b><br>The Hotel, its subsidiaries, affiliates, owner or its representatives have no obligation to monitor, track, record, store or disclose your use of the Services, including, without limitation, the URLs of the websites you visit and the data you enter, transmit, or receive, but may do so (i) to comply with legal or regulatory requirements or to assist in law enforcement investigations and procedures; (ii) to operate the Services properly; (iii) to ensure compliance with the terms and conditions herein; or (iv) based on a good faith belief that such monitoring, tracking, recording, storing, or disclosure is otherwise necessary or advisable including, without limitation, if there is reason to believe that such information is necessary to identify, contact or bring legal action against someone who may be causing interference with our rights or properties, whether intentionally or otherwise, or when anyone else could be harmed by such activities.<br><br><b>PROPRIETARY RIGHTS</b><br>You acknowledge and agree that all content and materials available to you through these Services are protected by Intellectual Property rights and laws. Reproduction, copying, or redistribution for commercial purposes of any materials or design elements obtained through these Services is strictly prohibited without the express written permission of Intellectual Property owner.<br><br><b>REVISIONS</b><br>The Hotel reserves the right, in it sole discretion, to update or revise these terms from time to time.`,
    }
  },
  filters: {
    phone: function (value) {
      if (!value) return '';
      value = value.toString();
      return '(' + value.substr(0,3) + ') ' + value.substr(3,3) + '-' + value.substr(6,4);
    }
  },
  mounted(){
    if(this.portal.template.support_phone){
      this.doc.support_phone = this.portal.template.support_phone;
    }

    this.generateRegistrationMethods();
  },
  methods: {
    handleError:function(error){
      this.$emit('emitCustomError',error);
    },
    generateRegistrationMethods:function(){
      for(var i in this.portal.registration_methods){
        var rm = this.portal.registration_methods[i];
        for(var c in rm.rate_plans){
          var rateplan = rm.rate_plans[c];
          var plan = {
            name: rm.free == 0 ? rateplan.rate_plan_name : rm.registration_method,
            type: 'rateplan',
            registration_method_id: rm.registration_method_id,
            id: rateplan.rateplan_id,
            price: rateplan.price,
            duration: rateplan.duration,
            speed_upload: rateplan.speed_upload,
            speed_download: rateplan.speed_download,
            additional_devices: rateplan.additional_devices,
            terms_of_service: this.terms_of_service,
          };
          this.registration_methods.push(plan);
        }
      }
      if(this.portal.access_codes.length>0){
        plan = {
          name: 'Access Code',
          type: 'accesscode',
          registration_method_id: 4,
          terms_of_service: this.terms_of_service,
        };
        this.registration_methods.push(plan);
      }
      if( this.registration_methods.length == 1 ){
        this.doc.selected_rm = 0;
      }
    },
    // Change selected registration method from emitted data
    changeSelected: function(index){
      this.doc.selected_rm = index;
    },
    // Change selected terms of service from emitted data
    changeSelectedTOS: function(index){
      this.doc.selected_tos = index;
    },
    changeButtonState: function(status){
      this.doc.buttonState = status.length
    },
    // Send registration method details back to parent
    emitRegistrationMethodData:function(emitted){
      // Check the template for v-on:emitRegistrationMethodData
      this.$emit('emitRegistrationMethodData',emitted);
    },

  }
}
</script>
<style>
.rm-header .row {
  display: none;
}


body {
    background-color: #17486d;
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
    color: #3f3b3a;
}
.main-logo {
    width: 20%;
    top: -30px;
    position: relative;
}
.spec-left {
  left: 0;
  z-index: 0;
  opacity: .2;
}

h1.standard {
  color:  #ccc;
  font-size: 40px;
  font-weight: bold;
}

.input-text {
    display: block;
    border-radius: 50px;
    border: none;
    color: white;
    overflow: visible;
    width: 85%;
    padding: 15px;
    font-size: 16px;
    background: #8781fc;
    text-align: center;
    margin: auto;
}

.dome-footer {
  margin:  0 auto;
}

::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: white;
  font-weight: bold;
  font-size: 25px;
  position: relative;
  top: 3px;
}
::-moz-placeholder { /* Firefox 19+ */
  color: white;
  font-weight: bold;
  font-size: 25px;
  position: relative;
  top: 3px;
}
:-ms-input-placeholder { /* IE 10+ */
  color: white;
  font-weight: bold;
  font-size: 25px;
  position: relative;
  top: 3px;
}
:-moz-placeholder { /* Firefox 18- */
  color: white;
  font-weight: bold;
  font-size: 25px;
  position: relative;
  top: 3px;
}

.studio-btn {
  width: 85%;
    background: white;
    border: none;
    color: #8781fc;
    border-radius: 50px;
    padding: 10px;
    font-weight: bold;
    font-size: 20px;
}

.studio-btn:hover {
  background:  #8781fc;
  color:  white;
  cursor: pointer;
}

.make-white {
  color:  white;
}

#pos-form {
  position: absolute;
    top: 50%;
    width: 400px;
    margin: 0 auto;
    border: 0;
    text-align: center;
    left: 50%;
    margin-left: -200px;
}

@media (max-width: 1120px){

  #pos-form { top: 40% }
}


img {
    display: inline-block;
    vertical-align: middle;
    max-width: 100%;
    height: auto;
    -ms-interpolation-mode: bicubic;
}
section.hold-content:before {
    content: '';
    background: linear-gradient(182.98deg, #16123D 2.85%, rgba(18,63,100,0.18) 14.05%, rgba(9,147,174,0) 21.48%, rgba(0,240,255,0) 29.61%),radial-gradient(517.67% 162.29% at 8.4% 9.17%, rgba(0,240,255,0.2) 0%, rgba(22,18,61,0) 100%),radial-gradient(191.58% 154.68% at 100% 73.95%, rgba(0,240,255,0.3) 0%, rgba(39,37,91,0) 100%),radial-gradient(2060.5% 99.01% at 0% 99.01%, #1D1B69 0%, rgba(29,27,108,0) 39.55%),linear-gradient(180deg, #070433 0%, #252353 100%),#101043;
    position: absolute;
    top: 0;
    width: 100%;
    height: 6000px;
    left: 0;
    z-index: -1;
}
.hold-content {
  position: relative;
  overflow: hidden;
  margin-top:  -30px;
}
.master {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
  section.home-hero {
    height: auto;
    min-height: 650px;
    position: relative;
    overflow: visible;
}
  article#homepage-content {
    min-height: calc(100vh - 130px);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
section.home-hero .floating-logos>img{
    position:absolute;
    z-index:0;
    height:100%;
    pointer-events:none
}
section.home-hero .floating-logos>img:last-of-type{
    right:0;
    pointer-events:none
}
@media (max-width: 1120px){
    section.home-hero .floating-logos>img:first-of-type{
        max-width:400px;
        height:auto
    }
    section.home-hero .floating-logos>img:last-of-type{
        max-width:500px;
        height:auto;
        bottom:0
    }
}
@media (max-width: 767px){
    section.home-hero .floating-logos>img:first-of-type{
        max-width:300px
    }
    section.home-hero .floating-logos>img:last-of-type{
        max-width:300px
    }
}
section.home-hero .floating-logos a{
    position:absolute;
    background:rgba(255,255,255,0.1);
    border-radius:20px;
    height:35px;
    line-height:35px;
    text-align:center;
    z-index:2;
    -webkit-transition:all 0.5s ease;
    transition:all 0.5s ease;
    width:80px;
    opacity:0.5
}
@media (max-width: 1120px){
    section.home-hero .floating-logos a{
        border-radius:10px;
        height:33px;
        line-height:33px;
        width:75px
    }
}
@media (max-width: 400px){
    section.home-hero .floating-logos a{
        height:30px;
        line-height:30px;
        width:66px
    }
}
section.home-hero .floating-logos a img{
    width:100%;
    -o-object-fit:contain;
    object-fit:contain;
    height:100%;
    max-height:15px;
    max-width:60px
}
@media (max-width: 1120px){
    section.home-hero .floating-logos a img{
        max-height:12px;
        max-width:58px
    }
}
section.home-hero .floating-logos a.image-main{
    width:120px;
    height:55px;
    line-height:55px;
    opacity:1
}
@media (max-width: 1120px){
    section.home-hero .floating-logos a.image-main{
        width:115px;
        height:50px;
        line-height:50px;
        border-radius:15px
    }
}
@media (max-width: 400px){
    section.home-hero .floating-logos a.image-main{
        width:105px;
        height:45px;
        line-height:45px
    }
}
section.home-hero .floating-logos a.image-main img{
    max-height:30px;
    max-width:80px
}
@media (max-width: 1120px){
    section.home-hero .floating-logos a.image-main img{
        max-height:25px;
        max-width:75px
    }
}
section.home-hero .floating-logos a:first-child{
    top:75px;
    left:227px
}
@media (max-width: 1120px){
    section.home-hero .floating-logos a:first-child{
        -webkit-transform:translateX(-100%);
        -ms-transform:translateX(-100%);
        transform:translateX(-100%)
    }
}
@media (max-width: 767px){
    section.home-hero .floating-logos a:first-child{
        left:64%
    }
}
section.home-hero .floating-logos a:nth-child(2){
    top:145px;
    left:137px
}
@media (max-width: 1120px){
    section.home-hero .floating-logos a:nth-child(2){
        -webkit-transform:translateX(-70%);
        -ms-transform:translateX(-70%);
        transform:translateX(-70%);
        top:145px
    }
}
@media (max-width: 767px){
    section.home-hero .floating-logos a:nth-child(2){
        -webkit-transform:translateX(-100%);
        -ms-transform:translateX(-100%);
        transform:translateX(-100%);
        left:49%;
        top:140px
    }
}
section.home-hero .floating-logos a:nth-child(3){
    top:75px;
    right:227px
}
@media (max-width: 1120px){
    section.home-hero .floating-logos a:nth-child(3){
        -webkit-transform:translateX(100%);
        -ms-transform:translateX(100%);
        transform:translateX(100%)
    }
}
@media (max-width: 767px){
    section.home-hero .floating-logos a:nth-child(3){
        left:95%;
        right:unset;
        -webkit-transform:translateX(-100%);
        -ms-transform:translateX(-100%);
        transform:translateX(-100%)
    }
}
section.home-hero .floating-logos a:nth-child(4){
    top:145px;
    right:137px
}
@media (max-width: 1120px){
    section.home-hero .floating-logos a:nth-child(4){
        -webkit-transform:translateX(70%);
        -ms-transform:translateX(70%);
        transform:translateX(70%);
        top:145px
    }
}
@media (max-width: 767px){
    section.home-hero .floating-logos a:nth-child(4){
        -webkit-transform:translateX(-100%);
        -ms-transform:translateX(-100%);
        transform:translateX(-100%);
        left:79%;
        right:unset;
        top:140px
    }
}
section.home-hero .floating-logos a:nth-child(5){
    left:137px;
    bottom:288px
}
@media (max-width: 1120px){
    section.home-hero .floating-logos a:nth-child(5){
        -webkit-transform:translateX(-80%);
        -ms-transform:translateX(-80%);
        transform:translateX(-80%)
    }
}
@media (max-width: 767px){
    section.home-hero .floating-logos a:nth-child(5){
        bottom:unset;
        left:33%;
        top:75px;
        -webkit-transform:translateX(-100%);
        -ms-transform:translateX(-100%);
        transform:translateX(-100%)
    }
}
section.home-hero .floating-logos a:nth-child(6){
    left:290px;
    bottom:261px
}
@media (max-width: 1120px){
    section.home-hero .floating-logos a:nth-child(6){
        -webkit-transform:translateX(-100%);
        -ms-transform:translateX(-100%);
        transform:translateX(-100%)
    }
}
@media (max-width: 767px){
    section.home-hero .floating-logos a:nth-child(6){
        bottom:180px;
        left:35%;
        -webkit-transform:translateX(-100%);
        -ms-transform:translateX(-100%);
        transform:translateX(-100%)
    }
}
section.home-hero .floating-logos a:nth-child(7){
    bottom:186px;
    left:202px
}
@media (max-width: 1120px){
    section.home-hero .floating-logos a:nth-child(7){
        -webkit-transform:translateX(-80%);
        -ms-transform:translateX(-80%);
        transform:translateX(-80%);
        bottom:195px
    }
}
@media (max-width: 767px){
    section.home-hero .floating-logos a:nth-child(7){
        -webkit-transform:translateX(-100%);
        -ms-transform:translateX(-100%);
        transform:translateX(-100%);
        bottom:180px;
        left:65%
    }
}
section.home-hero .floating-logos a:nth-child(8){
    left:355px;
    bottom:156px
}
@media (max-width: 1120px){
    section.home-hero .floating-logos a:nth-child(8){
        -webkit-transform:translateX(-100%);
        -ms-transform:translateX(-100%);
        transform:translateX(-100%);
        bottom:175px
    }
}
@media (max-width: 767px){
    section.home-hero .floating-logos a:nth-child(8){
        -webkit-transform:translateX(-100%);
        -ms-transform:translateX(-100%);
        transform:translateX(-100%);
        bottom:180px;
        left:95%
    }
}
section.home-hero .floating-logos a:nth-child(9){
    right:137px;
    bottom:288px
}
@media (max-width: 1120px){
    section.home-hero .floating-logos a:nth-child(9){
        -webkit-transform:translateX(80%);
        -ms-transform:translateX(80%);
        transform:translateX(80%)
    }
}
@media (max-width: 767px){
    section.home-hero .floating-logos a:nth-child(9){
        -webkit-transform:translateX(-100%);
        -ms-transform:translateX(-100%);
        transform:translateX(-100%);
        bottom:240px;
        right:unset;
        left:98%
    }
}
section.home-hero .floating-logos a:nth-child(10){
    right:290px;
    bottom:261px
}
@media (max-width: 1120px){
    section.home-hero .floating-logos a:nth-child(10){
        -webkit-transform:translateX(100%);
        -ms-transform:translateX(100%);
        transform:translateX(100%)
    }
}
@media (max-width: 767px){
    section.home-hero .floating-logos a:nth-child(10){
        -webkit-transform:translateX(0%);
        -ms-transform:translateX(0%);
        transform:translateX(0%);
        bottom:240px;
        right:unset;
        left:10px
    }
}
section.home-hero .floating-logos a:nth-child(11){
    bottom:186px;
    right:202px
}
@media (max-width: 1120px){
    section.home-hero .floating-logos a:nth-child(11){
        -webkit-transform:translateX(80%);
        -ms-transform:translateX(80%);
        transform:translateX(80%);
        bottom:195px
    }
}
@media (max-width: 767px){
    section.home-hero .floating-logos a:nth-child(11){
        -webkit-transform:translateX(-100%);
        -ms-transform:translateX(-100%);
        transform:translateX(-100%);
        bottom:120px;
        right:unset;
        left:80%
    }
}
section.home-hero .floating-logos a:nth-child(12){
    right:355px;
    bottom:156px
}
@media (max-width: 1120px){
    section.home-hero .floating-logos a:nth-child(12){
        -webkit-transform:translateX(100%);
        -ms-transform:translateX(100%);
        transform:translateX(100%);
        bottom:175px
    }
}
@media (max-width: 767px){
    section.home-hero .floating-logos a:nth-child(12){
        -webkit-transform:translateX(-100%);
        -ms-transform:translateX(-100%);
        transform:translateX(-100%);
        bottom:120px;
        right:unset;
        left:50%
    }
}
section.home-hero .floating-logos a:nth-child(13){
    left:110px;
    top:90px
}
@media (max-width: 1120px){
    section.home-hero .floating-logos a:nth-child(13){
        -webkit-transform:translateX(-120%);
        -ms-transform:translateX(-120%);
        transform:translateX(-120%)
    }
}
@media (max-width: 767px){
    section.home-hero .floating-logos a:nth-child(13){
        -webkit-transform:translateX(-100%);
        -ms-transform:translateX(-100%);
        transform:translateX(-100%);
        bottom:unset;
        top:135px;
        left:20%
    }
}
section.home-hero .floating-logos a:nth-child(14){
    right:110px;
    top:90px
}
@media (max-width: 1120px){
    section.home-hero .floating-logos a:nth-child(14){
        -webkit-transform:translateX(120%);
        -ms-transform:translateX(120%);
        transform:translateX(120%)
    }
}
@media (max-width: 767px){
    section.home-hero .floating-logos a:nth-child(14){
        -webkit-transform:translateX(-100%);
        -ms-transform:translateX(-100%);
        transform:translateX(-100%);
        top:135px;
        right:unset;
        left:98%
    }
}
section.home-hero .floating-logos a:nth-child(15){
    bottom:365px;
    left:70px
}
@media (max-width: 1120px){
    section.home-hero .floating-logos a:nth-child(15){
        -webkit-transform:translateX(-70%);
        -ms-transform:translateX(-70%);
        transform:translateX(-70%)
    }
}
@media (max-width: 767px){
    section.home-hero .floating-logos a:nth-child(15){
        bottom:300px;
        -webkit-transform:translateX(-100%);
        -ms-transform:translateX(-100%);
        transform:translateX(-100%)
    }
}
section.home-hero .floating-logos a:nth-child(16){
    bottom:220px;
    left:70px
}
@media (max-width: 1120px){
    section.home-hero .floating-logos a:nth-child(16){
        -webkit-transform:translateX(-80%);
        -ms-transform:translateX(-80%);
        transform:translateX(-80%)
    }
}
@media (max-width: 767px){
    section.home-hero .floating-logos a:nth-child(16){
        -webkit-transform:translateX(-100%);
        -ms-transform:translateX(-100%);
        transform:translateX(-100%);
        bottom:135px;
        left:20%
    }
}
section.home-hero .floating-logos a:nth-child(17){
    bottom:235px;
    left:460px
}
@media (max-width: 1120px){
    section.home-hero .floating-logos a:nth-child(17){
        -webkit-transform:translateX(-130%);
        -ms-transform:translateX(-130%);
        transform:translateX(-130%);
        bottom:90px
    }
}
@media (max-width: 767px){
    section.home-hero .floating-logos a:nth-child(17){
        -webkit-transform:translateX(-100%);
        -ms-transform:translateX(-100%);
        transform:translateX(-100%);
        bottom:135px;
        left:100%
    }
}
section.home-hero .floating-logos a:nth-child(18){
    bottom:110px;
    left:170px
}
@media (max-width: 1120px){
    section.home-hero .floating-logos a:nth-child(18){
        -webkit-transform:translateX(-100%);
        -ms-transform:translateX(-100%);
        transform:translateX(-100%);
        bottom:140px
    }
}
@media (max-width: 767px){
    section.home-hero .floating-logos a:nth-child(18){
        -webkit-transform:translateX(-100%);
        -ms-transform:translateX(-100%);
        transform:translateX(-100%);
        bottom:75px;
        left:47%
    }
}
section.home-hero .floating-logos a:nth-child(19){
    bottom:90px;
    left:330px
}
@media (max-width: 1120px){
    section.home-hero .floating-logos a:nth-child(19){
        -webkit-transform:translateX(-130%);
        -ms-transform:translateX(-130%);
        transform:translateX(-130%);
        bottom:115px
    }
}
@media (max-width: 767px){
    section.home-hero .floating-logos a:nth-child(19){
        bottom:75px;
        left:75%;
        -webkit-transform:translateX(-100%);
        -ms-transform:translateX(-100%);
        transform:translateX(-100%)
    }
}
section.home-hero .floating-logos a:nth-child(20){
    right:80px;
    bottom:370px;
    display:none
}
@media (max-width: 1120px){
    section.home-hero .floating-logos a:nth-child(20){
        -webkit-transform:translateX(70%);
        -ms-transform:translateX(70%);
        transform:translateX(70%)
    }
}
@media (max-width: 767px){
    section.home-hero .floating-logos a:nth-child(20){
        bottom:300px;
        right:50px
    }
}
section.home-hero .floating-logos a:nth-child(21){
    bottom:235px;
    right:460px
}
@media (max-width: 1120px){
    section.home-hero .floating-logos a:nth-child(21){
        -webkit-transform:translateX(130%);
        -ms-transform:translateX(130%);
        transform:translateX(130%)
    }
}
@media (max-width: 767px){
    section.home-hero .floating-logos a:nth-child(21){
        display:none
    }
}
section.home-hero .floating-logos a:nth-child(22){
    right:70px;
    bottom:220px
}
@media (max-width: 1120px){
    section.home-hero .floating-logos a:nth-child(22){
        -webkit-transform:translateX(80%);
        -ms-transform:translateX(80%);
        transform:translateX(80%)
    }
}
@media (max-width: 767px){
    section.home-hero .floating-logos a:nth-child(22){
        display:none
    }
}
section.home-hero .floating-logos a:nth-child(23){
    bottom:110px;
    right:170px
}
@media (max-width: 1120px){
    section.home-hero .floating-logos a:nth-child(23){
        -webkit-transform:translateX(100%);
        -ms-transform:translateX(100%);
        transform:translateX(100%);
        bottom:140px
    }
}
@media (max-width: 767px){
    section.home-hero .floating-logos a:nth-child(23){
        display:none
    }
}
section.home-hero .floating-logos a:nth-child(24){
    bottom:90px;
    right:330px
}
@media (max-width: 1120px){
    section.home-hero .floating-logos a:nth-child(24){
        -webkit-transform:translateX(130%);
        -ms-transform:translateX(130%);
        transform:translateX(130%);
        bottom:115px
    }
}
@media (max-width: 767px){
    section.home-hero .floating-logos a:nth-child(24){
        display:none
    }
}
section.home-hero .floating-logos a:not(:hover):not(.hovered){
    -webkit-box-shadow:0 4px 40px 10px transparent !important;
    box-shadow:0 4px 40px 10px transparent !important
}
section.home-hero .floating-logos a.image-notmain img{
    opacity:.2
}
@media (max-width: 767px){
    section.home-hero .floating-logos a.image-notmain img{
        opacity:0.7
    }
}
section.home-hero .floating-logos a:hover img,section.home-hero .floating-logos a.hovered img{
    opacity:1
}


@media (max-width: 767px){
  .main-logo {
    position: relative;
    top: -33px;
  }

  .dome-header {
    position: relative;
    top: -25px;
  }

  #pos-form {
    top: 50%;
  }

  article#homepage-content {
    min-height: 1100px;
  }

  section.home-hero {
    transition: all 0.5s ease;
    min-height: 780px;
    margin-bottom: 100px;
  }

  section.home-hero.shown {
    min-height: 880px;
    margin-bottom: 0;
  }

  h1.standard {
    position: relative;
    top: 100px;
  }
}

</style>
